export default __webpack_public_path__ + "313f7dacf2076822059d2dca26dedfc6.woff";